import { newToast } from '../components';
import useApi from '../utils/axios-pettitions';

export const useApiConfigWebPageResult = () => {
  const { runApi } = useApi();

  const getConfig = async () => {
    return runApi('WebPagePatientsCenters/getConfig', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const setConfig = async (dataConfig) => {
    runApi('WebPagePatientsCenters/UpdateConfig', 'POST', null, dataConfig).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return;
      }
    });
  };

  const migratePatients = async () => {
    return runApi('WebPagePatientsCenters/MigratePatients', 'POST', null, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return 0;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.data;
      }
      return 0;
    });
  };

  const getCenters = async () => {
    return runApi('WebPagePatientsCenters/GetCenters', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getPatients = async (user) => {
    return runApi('WebPagePatientsCenters/GetPatients', 'GET', { user }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const getListCentersEquival = async () => {
    return runApi('WebPagePatientsCenters/GetListCentersEquival', 'GET', null, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return [];
      } else if (res.internalCode === 101) {
        return res.data;
      }
      return [];
    });
  };

  const createUser = async (id, user, password) => {
    return runApi('WebPagePatientsCenters/CreateUser', 'POST', { id, user, password }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return false;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  const restorePassword = async (Id, Password) => {
    return runApi('WebPagePatientsCenters/restorePassword', 'POST', null, { Id, Password }).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 3);
        return false;
      } else if (res.internalCode === 107 && res.data) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  return {
    getConfig,
    setConfig,
    migratePatients,
    createUser,
    restorePassword,
    getCenters,
    getPatients,
    getListCentersEquival,
  };
};
